module.exports = __webpack_public_path__ + "pdk0-32.jpg?29a8951e97c50aa572d92834df4bf97e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk0-32.jpg
// module id = 74
// module chunks = 0